module.exports = __webpack_public_path__ + "img/hospitium-03.e7964568.jpg";